import { render, staticRenderFns } from "./ImportNfePage.vue?vue&type=template&id=650710d0&scoped=true&"
import script from "./ImportNfePage.vue?vue&type=script&lang=js&"
export * from "./ImportNfePage.vue?vue&type=script&lang=js&"
import style0 from "./ImportNfePage.vue?vue&type=style&index=0&id=650710d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650710d0",
  null
  
)

export default component.exports